import { makeHttpRequest } from "@/shared";

export const deletePoints = async (ids) => {
    return (
        await makeHttpRequest({
            url: "/point/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;
};
